/**
 * Milestones for scroll depth (vertical page scroll and horizontal rails).
 * Matches {@link PageScrollEvents} defaults.
 */
export const DEFAULT_SCROLL_PERCENTAGE_THRESHOLDS: readonly number[] = [
  15, 30, 50, 70, 90,
];
